export default "__VITE_ASSET__7f35c629__"